import { NavLink } from "react-router-dom";
import classNames from "./SideNav.module.css";
import {
  IoHeadsetOutline,
  IoHomeOutline,
  IoSettingsOutline,
  IoVideocamOutline,
  IoWalletOutline,
} from "react-icons/io5";
import { useMatch } from "react-router-dom";
import { useOrganization } from "../../context/organization/organization";
import Loader from "../../common/Loader";
import { BsClock } from "react-icons/bs";

export default function SideNav() {
  const { organization, loading } = useOrganization();
  const isSettingsActive = useMatch("/settings/*");

  if (!organization || loading) {
    return <Loader />;
  }

  return (
    <nav className={classNames.SideNav}>
      <NavLink
        end
        to="/"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <IoHomeOutline />
        Home
      </NavLink>
      <NavLink
        to="/meetings"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <IoVideocamOutline />
        Meetings & events
      </NavLink>
      <NavLink
        to="/settings"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <IoSettingsOutline />
        Account settings
      </NavLink>
      {/* Settings sub-nav */}
      {isSettingsActive && (
        <nav className={classNames.SettingsSubNav}>
          <NavLink
            end
            to="/settings"
            className={({ isActive }) =>
              isActive ? classNames.Active : undefined
            }
          >
            Admin management
          </NavLink>
          <NavLink
            to="/settings/languages"
            className={({ isActive }) =>
              isActive ? classNames.Active : undefined
            }
          >
            Languages
          </NavLink>
          {organization.glossary_enabled && (
            <NavLink
              to="/settings/glossary"
              className={({ isActive }) =>
                isActive ? classNames.Active : undefined
              }
            >
              Glossary
            </NavLink>
          )}
          {organization.voice_translation_enabled && (
            <NavLink
              to="/settings/voice-translation"
              className={({ isActive }) =>
                isActive ? classNames.Active : undefined
              }
            >
              Voice translation
            </NavLink>
          )}
          {organization.voice_translation_enabled && (
            <NavLink
              to="/settings/voice-avatars"
              className={({ isActive }) =>
                isActive ? classNames.Active : undefined
              }
            >
              Voice avatars
            </NavLink>
          )}
          {organization.recording_enabled && (
            <NavLink
              to="/settings/recording"
              className={({ isActive }) =>
                isActive ? classNames.Active : undefined
              }
            >
              Recording
            </NavLink>
          )}
          <NavLink
            to="/settings/qna"
            className={({ isActive }) =>
              isActive ? classNames.Active : undefined
            }
          >
            Q&A
          </NavLink>
          <NavLink
            to="/settings/text-translation"
            className={({ isActive }) =>
              isActive ? classNames.Active : undefined
            }
          >
            Text translation
          </NavLink>
        </nav>
      )}
      <NavLink
        to="/billing"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <IoWalletOutline />
        Plan & billing
      </NavLink>
      <NavLink
        to="/usage"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <BsClock />
        Usage
      </NavLink>
      <NavLink
        to="/support"
        className={({ isActive }) => (isActive ? classNames.Active : undefined)}
      >
        <IoHeadsetOutline />
        Support
      </NavLink>
    </nav>
  );
}
